// Single source of truth for who can reach System Overview (AdminPanel,
// now at the top-level /app/system route) — shared by SystemOverviewGate.jsx
// (the route-level gate) and sidebarNav.mjs (the nav-visibility check) so
// the two can't drift apart.
//
// This used to be SETTINGS_SECTIONS.system.requireAny in
// pages/settings/sections.js. The Settings IA rebuild (2026-07) relocated
// System Overview out of the Settings taxonomy entirely (it's an
// operational health dashboard, not configuration) — this module is what
// replaces that shared reference now that sections.js has no 'system'
// section to point at.
export const SYSTEM_OVERVIEW_REQUIRE_ANY = ['manage_users', 'approve_signups']
